
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9vJRo", function(module, exports) {

$parcel$export(module.exports, "HomeOnboardingTakeoverV2HomeNudge", () => $4ac6d1a639d952f5$export$7f711697718dffe7);

var $gwFzn = parcelRequire("gwFzn");

var $aDe4X = parcelRequire("aDe4X");

var $7yh19 = parcelRequire("7yh19");

var $1OJav = parcelRequire("1OJav");
const $4ac6d1a639d952f5$export$7f711697718dffe7 = ({ children: children, position: position = 'bottom-start' })=>{
    const { isEligible: v2NthUserEligible, loading: v2NthUserLoading } = (0, $aDe4X.useNthUserHomeOnboardingTakeoverV2Eligibility)();
    if (v2NthUserLoading) return children;
    if (v2NthUserEligible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1OJav.NthUserHomeOnboardingTakeoverV2HomeNudge), {
        position: "bottom-start"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7yh19.AdminHomeOnboardingTakeoverV2HomeNudge), {
        position: position
    }, children);
};

});
parcelRegister("7yh19", function(module, exports) {

$parcel$export(module.exports, "AdminHomeOnboardingTakeoverV2HomeNudge", () => $d4ecea012e53d33c$export$82143e260564fcf9);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $bUlM5 = parcelRequire("bUlM5");

var $inPa6 = parcelRequire("inPa6");

var $1cuAd = parcelRequire("1cuAd");

var $9Yv8Z = parcelRequire("9Yv8Z");

var $ivb8S = parcelRequire("ivb8S");

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $lsxnT = parcelRequire("lsxnT");

var $9yCWZ = parcelRequire("9yCWZ");

var $ip2xe = parcelRequire("ip2xe");

var $eiM6s = parcelRequire("eiM6s");
//TODO before merge add descriptions
const $d4ecea012e53d33c$var$i18n = (0, $2nPZH.defineMessages)({
    dismissCTA: {
        id: "experiment-home-onboarding-takeover-v2.home-nudge.dismiss-cta",
        defaultMessage: "Dismiss"
    },
    goHomeCTA: {
        id: "experiment-home-onboarding-takeover-v2.home-nudge.go-home-cta.",
        defaultMessage: "Go Home"
    },
    description: {
        id: "experiment-home-onboarding-takeover-v2.home-nudge.description",
        defaultMessage: "When you\u2019re ready to continue onboarding, head back Home."
    }
});
const $d4ecea012e53d33c$var$NudgeFixer = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "column",
        justifyContent: "center"
    }, children);
};
const $d4ecea012e53d33c$export$82143e260564fcf9 = ({ children: children, position: position = 'bottom-start' })=>{
    const [isHomeNudgeHidden, setIsHomeNudgeHidden] = (0, $gwFzn.useState)(true);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    // This is the onboarding state hidden
    const { isEligibleForHomeNudge: isEligibleForHomeNudge, isOnHome: isOnHome, error: error } = (0, $ip2xe.useIsEligibleForAdminHomeOnboardingTakeoverV2HomeNudge)();
    const wasEligibleForOnboardingNudgeRef = (0, $gwFzn.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const expandSideNav = (0, $1cuAd.useExpandSideNav)();
    const { getIsXflowTakeoverType: getIsXflowTakeoverType } = (0, $eiM6s.useHTV2Actions)();
    const isXflow = getIsXflowTakeoverType();
    const homeNudgeChoreographer = useChoreographer('admin-home-onboarding-takeover-v2-home-nudge', {
        start: ()=>setIsHomeNudgeHidden(false),
        stop: ()=>setIsHomeNudgeHidden(true)
    });
    const handleDismiss = ()=>{
        setIsHomeNudgeHidden(true);
        homeNudgeChoreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2HomeNudgeDismiss',
                source: 'onboarding',
                attributes: {
                    isXflow: isXflow
                }
            }
        }).fire();
    };
    const handleGoHome = ()=>{
        push((0, $1NBp8.HOME).toUrl());
        homeNudgeChoreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'homeOnboardingTakeoverV2HomeNudgeGoHome',
                source: 'onboarding',
                attributes: {
                    isXflow: isXflow
                }
            }
        }).fire();
    };
    (0, $gwFzn.useEffect)(()=>{
        if (isEligibleForHomeNudge && isHomeNudgeHidden && !wasEligibleForOnboardingNudgeRef.current) {
            setOnboardingState({
                key: (0, $9yCWZ.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasSeenHomeNudge,
                value: 'true'
            });
            homeNudgeChoreographer.startMessage();
            expandSideNav();
            wasEligibleForOnboardingNudgeRef.current = true;
        }
    }, [
        isEligibleForHomeNudge,
        isHomeNudgeHidden,
        setOnboardingState,
        homeNudgeChoreographer,
        expandSideNav
    ]);
    const isNudgeHidden = !isHomeNudgeHidden && (wasEligibleForOnboardingNudgeRef.current || isEligibleForHomeNudge);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Yv8Z.OnboardingNudge), {
        hidden: !isNudgeHidden || isOnHome,
        setHidden: ()=>homeNudgeChoreographer.stopMessage(),
        position: position,
        wrapper: $d4ecea012e53d33c$var$NudgeFixer,
        actions: [
            {
                onClick: handleGoHome,
                text: formatMessage($d4ecea012e53d33c$var$i18n.goHomeCTA)
            },
            {
                onClick: handleDismiss,
                text: formatMessage($d4ecea012e53d33c$var$i18n.dismissCTA)
            }
        ],
        actionSubjectId: "admin-home-onboarding-takeover-v2-home-nav-item",
        key: "admin-home-onboarding-takeover-v2-home-nav-item",
        width: 275,
        source: "onboarding",
        content: formatMessage($d4ecea012e53d33c$var$i18n.description),
        renderChildrenWhileLoading: true
    }, children, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};

});
parcelRegister("ip2xe", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForAdminHomeOnboardingTakeoverV2HomeNudge", () => $314b6c81c93813ef$export$a072c9ec9771b56);

var $ivb8S = parcelRequire("ivb8S");

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");

var $dN1MH = parcelRequire("dN1MH");

var $6mKj3 = parcelRequire("6mKj3");

var $9yCWZ = parcelRequire("9yCWZ");
const $314b6c81c93813ef$export$a072c9ec9771b56 = ({ skip: skip = false } = {})=>{
    const isOnHomeOrWikiRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.WIKI).name || routeName === (0, $1NBp8.HOME).name;
        }
    };
    const isOnHome = (0, $dPJCf.useRouteName)(isOnHomeOrWikiRouteArgs);
    const { isSpaceGettingStartedTourExperimentCohort: isSpaceGettingStartedTourExperimentCohort, loading: isSpaceGettingStartedTourExperimentCohortLoading } = (0, $dN1MH.useIsSpaceGettingStartedTourEligible)();
    const localSkip = skip || isOnHome || !(0, $6mKj3.expValEqualsNoExposure)('cc_home_onboarding_takeover_v2_xflow', 'cohort', 'experiment') || isSpaceGettingStartedTourExperimentCohortLoading || isSpaceGettingStartedTourExperimentCohort;
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $9yCWZ.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS)), localSkip);
    const { hasSeenHomeNudge: hasSeenHomeNudge, takeoverSeenAt: takeoverSeenAt, hasDismissedTakeover: hasDismissedTakeover } = (0, $ivb8S.deserializeState)(data);
    if (localSkip || loading || error) return {
        isEligibleForHomeNudge: false,
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
    return {
        isEligibleForHomeNudge: Boolean(!hasSeenHomeNudge && takeoverSeenAt && !hasDismissedTakeover && !isSpaceGettingStartedTourExperimentCohortLoading && !isSpaceGettingStartedTourExperimentCohort),
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
};

});
parcelRegister("dN1MH", function(module, exports) {

$parcel$export(module.exports, "useIsSpaceGettingStartedTourEligible", () => $e0112b4b5678390a$export$1acf677bd8c1a068);
// import { UNSAFE_noExposureExp } from '@confluence/feature-experiments';
// import { isMobileUserAgent, shouldShowMobileWeb } from '@confluence/mobile-detection';
// import { useSessionData, AccessStatus } from '@confluence/session-data';
// import { Cohorts } from '@confluence/onboarding-helpers/entry-points/constants/cohorts';
// ^ note this file is deprecated due to CONFONBO-5541
// import { ONBOARDING_EXPERIENCES } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants';
// import { useIsXflowUser } from '@confluence/onboarding-helpers/entry-points/hooks/useIsXflowUser';
// import {
// 	useGetOnboardingState,
// 	deserializeState,
// } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
/**
 * Eligiblity check
 * 1. Desktop only
 * 2. user is new
 * 3. user is a licensed admin
 * 4. user is a founding admin

 *
 * Results
 * 1. isEligibleForSpaceGettingStartedTour = user meets Eligiblity check and is not in "NOT_ENROLLED"
 * 2. isSpaceGettingStartedTourExperimentCohort = user meets Eligiblity check and is in "EXPERIMENT"
 *
 */ const $e0112b4b5678390a$export$1acf677bd8c1a068 = ()=>{
    // const { accessStatus, isLoggedIn } = useSessionData();
    // // const [xflowExperiment] = UNSAFE_noExposureExp('cc_getting_started_tour_xflow');
    // // const cohortXflow = xflowExperiment.get<'experiment' | 'not-enrolled' | 'control'>(
    // // 	'cohort',
    // // 	'not-enrolled',
    // // );
    // const [landExperiment] = UNSAFE_noExposureExp('cc_getting_started_tour');
    // const cohortLandAndOther = landExperiment.get<'experiment' | 'not-enrolled' | 'control'>(
    // 	'cohort',
    // 	'not-enrolled',
    // );
    // //1. Experiment eligbile for desktop only
    // const isDesktopUser = !(isMobileUserAgent() || shouldShowMobileWeb());
    // //2. user is new - For experiment add FG filter on activation date
    // // [TODO] Productionize ticket https://hello.jira.atlassian.cloud/browse/CONFONBO-4575
    // //3. user is a licensed admin
    // const isLicensedAdmin = isLoggedIn && accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS;
    // /**
    //  * skip = true when both land/xflow experiment flag is not enrolled
    //  */
    // const skipConditionsForQueries =
    // 	!isDesktopUser || !isLicensedAdmin || cohortLandAndOther === Cohorts.NOT_ENROLLED;
    // //4. user is a founding admin
    // const {
    // 	data: onboardingStateData,
    // 	loading: onboardingStateLoading,
    // 	error: onboardingStateError,
    // } = useGetOnboardingState(
    // 	Object.values({
    // 		...ONBOARDING_EXPERIENCES,
    // 	}),
    // 	skipConditionsForQueries,
    // );
    // const { isFoundingAdmin } = deserializeState(onboardingStateData);
    // //5. land users belong to land experiment; xflow users belong to crossflow experiment
    // const {
    // 	isXflowUser,
    // 	isLoading: isXflowUserLoading,
    // 	error: isXflowUserError,
    // } = useIsXflowUser({
    // 	skip: skipConditionsForQueries || !isFoundingAdmin,
    // });
    // //  Check overall eligibility criteria
    // const meetsExperimentTargetingCriteria = isFoundingAdmin && isDesktopUser;
    // //---------------------------------
    // // To know final result, all query has to finished
    // const hasAllQueryFinished =
    // 	!onboardingStateLoading && !onboardingStateError && !isXflowUserLoading && !isXflowUserError;
    return {
        isLandAndOtherEligibleForSpaceGettingStartedTour: false,
        isXflowEligibleForSpaceGettingStartedTour: false,
        isSpaceGettingStartedTourExperimentCohort: false,
        loading: false,
        error: false
    };
};

});



parcelRegister("1OJav", function(module, exports) {

$parcel$export(module.exports, "NthUserHomeOnboardingTakeoverV2HomeNudge", () => $d3cc8422fc7cecaf$export$8ee05f5dc902d0f5);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $bUlM5 = parcelRequire("bUlM5");

var $inPa6 = parcelRequire("inPa6");

var $1cuAd = parcelRequire("1cuAd");

var $9Yv8Z = parcelRequire("9Yv8Z");

var $ivb8S = parcelRequire("ivb8S");

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");

var $dIouf = parcelRequire("dIouf");

var $lsxnT = parcelRequire("lsxnT");

var $9yCWZ = parcelRequire("9yCWZ");

var $c0tZa = parcelRequire("c0tZa");
const $d3cc8422fc7cecaf$var$i18n = (0, $2nPZH.defineMessages)({
    homeSpotlightHeader: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.header",
        defaultMessage: "Get started with Confluence"
    },
    homeSpotlightText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.text",
        defaultMessage: "Quickly learn about Confluence and become a Confluence expert"
    },
    homeSpotlightCloseButtonText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-dismiss",
        defaultMessage: "Dismiss"
    },
    homeSpotlightTryItButtonText: {
        id: "experiment-home-onboarding-takeover-v2.nth-user-home-nudge.button-try-it",
        defaultMessage: "Try it"
    }
});
const $d3cc8422fc7cecaf$var$NudgeFixer = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "column",
        justifyContent: "center"
    }, children);
};
const $d3cc8422fc7cecaf$export$8ee05f5dc902d0f5 = ({ children: children, position: position = 'bottom-start' })=>{
    const [isHomeNudgeHidden, setIsHomeNudgeHidden] = (0, $gwFzn.useState)(true);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    // This is the onboarding state hidden
    const { isEligibleForHomeNudge: isEligibleForHomeNudge, isOnHome: isOnHome, error: error } = (0, $c0tZa.useIsEligibleForNthUserHomeOnboardingTakeoverV2HomeNudge)();
    const wasEligibleForOnboardingNudgeRef = (0, $gwFzn.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const expandSideNav = (0, $1cuAd.useExpandSideNav)();
    const homeNudgeChoreographer = useChoreographer('nth-user-home-onboarding-takeover-v2-home-nudge', {
        start: ()=>setIsHomeNudgeHidden(false),
        stop: ()=>setIsHomeNudgeHidden(true)
    });
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                action: 'viewed',
                name: 'nthUserHomeOnboardingTakeoverV2HomeNudge'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleDismiss = ()=>{
        setIsHomeNudgeHidden(true);
        homeNudgeChoreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'nthUserHomeOnboardingTakeoverV2HomeNudgeDismiss',
                source: 'onboarding'
            }
        }).fire();
    };
    const handleGoHome = ()=>{
        push((0, $1NBp8.HOME).toUrl());
        homeNudgeChoreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'nthUserHomeOnboardingTakeoverV2HomeNudgeGoHome',
                source: 'onboarding'
            }
        }).fire();
    };
    (0, $gwFzn.useEffect)(()=>{
        if (isEligibleForHomeNudge && isHomeNudgeHidden && !wasEligibleForOnboardingNudgeRef.current) {
            setOnboardingState({
                key: (0, $9yCWZ.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS).hasSeenHomeNudge,
                value: 'true'
            });
            homeNudgeChoreographer.startMessage();
            expandSideNav();
            wasEligibleForOnboardingNudgeRef.current = true;
        }
    }, [
        isEligibleForHomeNudge,
        isHomeNudgeHidden,
        setOnboardingState,
        homeNudgeChoreographer,
        expandSideNav
    ]);
    const isNudgeHidden = !isHomeNudgeHidden && (wasEligibleForOnboardingNudgeRef.current || isEligibleForHomeNudge);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Yv8Z.OnboardingNudge), {
        hidden: !isNudgeHidden || isOnHome,
        setHidden: ()=>homeNudgeChoreographer.stopMessage(),
        position: position,
        wrapper: $d3cc8422fc7cecaf$var$NudgeFixer,
        heading: formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightHeader),
        actions: [
            {
                onClick: handleGoHome,
                text: formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightTryItButtonText)
            },
            {
                onClick: handleDismiss,
                text: formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightCloseButtonText)
            }
        ],
        actionSubjectId: "nth-user-home-onboarding-takeover-v2-home-nav-item",
        key: "nth-user-home-onboarding-takeover-v2-home-nav-item",
        width: 275,
        source: "onboarding",
        content: formatMessage($d3cc8422fc7cecaf$var$i18n.homeSpotlightText),
        renderChildrenWhileLoading: true
    }, children, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};

});
parcelRegister("c0tZa", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForNthUserHomeOnboardingTakeoverV2HomeNudge", () => $996603fe96782b8b$export$8f136d122118bae4);

var $ivb8S = parcelRequire("ivb8S");

var $dPJCf = parcelRequire("dPJCf");

var $1NBp8 = parcelRequire("1NBp8");

var $dN1MH = parcelRequire("dN1MH");

var $6mKj3 = parcelRequire("6mKj3");

var $9yCWZ = parcelRequire("9yCWZ");
const $996603fe96782b8b$export$8f136d122118bae4 = ({ skip: skip = false } = {})=>{
    const isOnHomeOrWikiRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.WIKI).name || routeName === (0, $1NBp8.HOME).name;
        }
    };
    const isOnHome = (0, $dPJCf.useRouteName)(isOnHomeOrWikiRouteArgs);
    const { isSpaceGettingStartedTourExperimentCohort: isSpaceGettingStartedTourExperimentCohort, loading: isSpaceGettingStartedTourExperimentCohortLoading } = (0, $dN1MH.useIsSpaceGettingStartedTourEligible)();
    const localSkip = skip || isOnHome || !(0, $6mKj3.expValEqualsNoExposure)('cc_onboarding_nth_user_home_takeover', 'cohort', 'experiment') || isSpaceGettingStartedTourExperimentCohortLoading || isSpaceGettingStartedTourExperimentCohort;
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $9yCWZ.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS)), localSkip);
    const { hasSeenHomeNudge: hasSeenHomeNudge, takeoverSeenAt: takeoverSeenAt, hasDismissedTakeover: hasDismissedTakeover } = (0, $ivb8S.deserializeState)(data);
    if (localSkip || loading || error) return {
        isEligibleForHomeNudge: false,
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
    return {
        isEligibleForHomeNudge: Boolean(!hasSeenHomeNudge && !takeoverSeenAt && !hasDismissedTakeover && !isSpaceGettingStartedTourExperimentCohortLoading && !isSpaceGettingStartedTourExperimentCohort),
        isOnHome: isOnHome,
        loading: loading,
        error: error
    };
};

});




//# sourceMappingURL=AppNavigation.7293a585.js.map
